import { IUploadStatus } from "@Models/IActivityDetails";
import React, { createContext, ReactNode, useState } from "react";
import { RcFile } from "antd/lib/upload";
import { IModalState } from "@Constants";

export interface IModalDataState {
    status: IModalState;
    pendingFile?: RcFile;
    activityInstanceId?: string;
    metadata: {
        title: string;
        description?: string;
        tags?: string[];
        isPublic?: boolean;
        isCMEPublic?: boolean;
        questionnaireId?: string;
        creationDate?: moment.Moment;
    };
}

type ActivityUploadContextType = {
    percentage: number;
    setPercentage: (percentage: number) => void;
    modalState: IModalDataState;
    setModalState: (state: IModalDataState) => void;
    uploadStatus: IUploadStatus;
    setUploadStatus: (state: IUploadStatus) => void;
};

export const ActivityUploadContext = createContext<ActivityUploadContextType>({
    percentage: 0,
    setPercentage: () => {},
    modalState: {
        status: IModalState.Standard,
        pendingFile: undefined,
        metadata: {
            title: undefined,
            description: undefined,
            tags: undefined,
            isPublic: undefined,
            isCMEPublic: undefined,
            questionnaireId: undefined,
            creationDate: undefined,
        },
    },
    setModalState: () => {},
    uploadStatus: "idle",
    setUploadStatus: () => {},
});

export const ActivityUploadProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [percentage, setPercentage] = useState<number>(0);
    const [uploadStatus, setUploadStatus] = useState<IUploadStatus>("idle");
    const [modalState, setModalState] = useState<IModalDataState>({
        status: IModalState.Standard,
        activityInstanceId: undefined,
        pendingFile: undefined,
        metadata: {
            title: undefined,
            description: undefined,
            tags: undefined,
            isPublic: undefined,
            isCMEPublic: undefined,
            questionnaireId: undefined,
            creationDate: undefined,
        },
    });

    return (
        <ActivityUploadContext.Provider
            value={{
                percentage,
                setPercentage,
                modalState,
                setModalState,
                uploadStatus,
                setUploadStatus,
            }}
        >
            {children}
        </ActivityUploadContext.Provider>
    );
};
